/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */

import axios from '@/axios.js'
import store from '@/store/store.js'

export default {
  addDA ({ commit }, daObj) {
    return new Promise((resolve, reject) => {
      store.dispatch("development-actions/create", daObj)
        .then((response) => {
         // commit("SET_USERS_DEVELOPMENT_ACTION", response.data);
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDA ({ commit }, query) {
    return new Promise((resolve, reject) => {
      store.dispatch("development-actions/find", query)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateDA ({ commit }, daObj) {
    return new Promise((resolve, reject) => {
      store.dispatch("development-actions/patch", [daObj.id, daObj])
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
